var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import "normalize.css";
import { createGlobalStyle } from "styled-components";
import { colors } from "./colors";
import { fontFamilies } from "./font-families";
export var GlobalStyles = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n*,\n*:before,\n*:after {\n  box-sizing: inherit;\n}\n\nhtml {\n  font-size: 62.5%;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: ", ";\n  font-size: 1.5rem;\n  margin: 0;\n  color: ", ";\n}\n\nimg,\nsvg {\n  max-width: 100%;\n  vertical-align: middle;\n}\n"], ["\n*,\n*:before,\n*:after {\n  box-sizing: inherit;\n}\n\nhtml {\n  font-size: 62.5%;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: ", ";\n  font-size: 1.5rem;\n  margin: 0;\n  color: ", ";\n}\n\nimg,\nsvg {\n  max-width: 100%;\n  vertical-align: middle;\n}\n"])), fontFamilies.sansSerif, colors.gray[900]);
var templateObject_1;